module.exports = __webpack_public_path__ + "img/Amazon_Web_Services_Logo.a31fe792.svg";